export default "__VITE_ASSET__ClPQO2Kl__"